// 중계방 입구. 로그인 화면과 상단 메뉴 양쪽에서 쓴다. 방송 중일 때만 LIVE 표시가 붙는다.
// 상태는 들어올 때 한 번만 확인한다 — 주기적으로 다시 묻지 않는다.
import { useEffect, useState } from 'react';
import { loadBroadcastState } from '../api/broadcastApi.js';
import '../../../styles/broadcast-entry.css';

export function BroadcastEntryButton({ variant = 'auth' }) {
  const [live, setLive] = useState(false);
  // 운영진이 입장을 닫아 두면 버튼 자체를 내린다. 서버도 같이 막으므로 주소를 알아도 못 들어온다.
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let cancelled = false;
    loadBroadcastState()
      .then((state) => {
        if (cancelled) return;
        setLive(state?.isLive === true);
        setVisible(state?.entryEnabled !== false);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!visible) return null;

  return (
    <a className={`broadcast-entry ${variant} ${live ? 'live' : ''}`} href="#/broadcast">
      {live ? <span className="broadcast-entry-live">🔴 LIVE</span> : null}
      <span>중계방{variant === 'auth' ? ' 입장' : ''}</span>
      {variant === 'auth' && !live ? <small>방송이 없을 때도 들어갈 수 있습니다.</small> : null}
    </a>
  );
}
